const loadScripts = (imports: Array<Promise<void>>) => {
    Promise.all(imports).then(() => {
        import(
            /* webpackChunkName: "wand" */
            /* webpackMode: "eager" */
            './app'
        );
    });
};

const polyfills = [];

// @ts-ignore
if (!window.IntersectionObserver) {
    polyfills.push(
        import(
            /* webpackChunkName: "intersection-observer" */
            /* webpackMode: "lazy" */
            // @ts-ignore
            'intersection-observer'
        ),
    );
}

if (!window.ResizeObserver) {
    polyfills.push(
        import(
            /* webpackChunkName: "resize-observer" */
            /* webpackMode: "lazy" */
            '@juggle/resize-observer'
        ).then((module) => {
            // @ts-ignore
            window.ResizeObserver = module.ResizeObserver;
        }),
    );
}

loadScripts(polyfills);
